import { useAuth } from '../contexts/AuthContext';

export const useAuthUser = () => {
  const { user, authenticated, loading } = useAuth();
  
  return {
    user,
    authenticated,
    loading,
    isAuthenticated: authenticated,
    currentUser: user
  };
}; 